import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { WalletService } from '../../Services/wallet.service';
import { UserService } from '../../Services/user.service';
import { OtcService } from '../../Services/otc.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LangService } from '../../Services/lang.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { PlatformLocation } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { GlobalConstants } from '../../common/global-constans';
import { SliceAmount } from 'src/app/common/utils';

declare var $: any;
declare var SockJS: any;
declare var Stomp: any;

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})

export class CalculatorComponent implements OnInit, OnDestroy {

  @Input() isDisabled: boolean = false;
  @Output() btnClick = new EventEmitter();
  @Input() isFilterDrop: boolean;
  // GENERAL DATA
  tokenApp = false;
  userData: any = {};
  walletInfo: any = {};
  coinName: any = '';
  coinName2: any = '';
  type: any = '';
  typeValue: any = '';
  selectedCoin: any = {};
  currentCoin: any = {};
  selectedCoin2: any = {};
  selectedCoinShortName: any = '';
  selectedCoinShortName2: any = '';
  fee: any = {};
  rangeMarket = 0.05;
  buySellStatus: any = {};
  markerPrice: any;
  markerPrice2: any;
  form: FormGroup;
  tradecode: any = '';
  unsubscribe$: Subject<void> = new Subject<void>();
  fecthMarketPrice: any = 0;
  isActiveSroll: any = false;
  checkValidate: any = false;


  // FILTERS DATA
  searchOrder: any = {
    country: [],
    minAmount: 0,
    minReputation: 0,
    paymentMethod: 'ALL',
    preferredCurrency: 'ALL'
  };
  searchOrderData: any = {};
  filter: any = {
    preferredCurrency: 'ALL',
    paymentMethod: 'ALL',
    country: [],
    paymentMethodImage: '',
    advance: false,
    textToFilter: ''
  };
  isFilter: any = false;
  filterOrders: any = [];
  listTypes: any = [];
  dropdownList: any = [];
  selectedItems: any = [];
  dropdownSettings: any = {};
  isInvalidPrice: any = false;
  orderTypes: any = [];
  sortType: string;


  // PAYMENT METHODS DATA
  availableBanks: any = [];
  availablePaymentMethods: any = [];
  availablePaymentMethodsList: any = [];
  savedPaymentMethods: any = [];
  savedPaymentObj: any = {};
  giftCards: any = [];
  deletedPaymentMethod: any = {};
  paymentMethodToDelete: any;
  editOrDeleteEvents = false;

  // SELECT PAYMENT METHODS CONTROL
  public searchBuySellValue = '';
  public searchTakeValue = '';
  public searchTakeValuePaymentCountry = '';
  public searchTakeValuePaymentCountry2 = '';
  public searchTakeValuePaymentCountry3 = '';
  public searchBank1Value = '';
  public searchBank2Value = '';
  public searchBank3Value = '';
  public searchBank4Value = '';
  giftCardsList: any = [];
  marketPriceActive: any = false;
  orderExpirationDate: any;
  coinsListFilter: any = [];
  coinsListFilter2: any = [];
  coinList: any = [];

  // CURRENCIES DATA
  currencies: any = [];
  currencyVallues: any = [];
  curntCurencyValue: any = {};
  buySellCurrency: any;
  buySellCurrencyName: any;
  currenciesList: any = [];

  // BANK AND COUNTRIES DATA
  countries: any = [];
  countriesList: any = [];
  filteredBanks: any = [];
  countryListPM: any = [];
  countryListPM1: any = [];
  countryListPM2: any = [];
  bankListPM: any = [];
  bankTransferType: any = '';


  // WEB SOCKETS DATA
  stompClient: any;
  priceStompClient: any;
  socketConnected: any = false;


  // LOADING CONTROL
  loading: any = false;
  loadingCreateOrder: any = false;
  loadingTakeOrder: any = false;
  orderLoaded: any = false;
  buySellStatusLoaded: any = false;
  disabledClass: any = 'disabled';

  // FEE CONTROL
  expirationDays: any = 15;
  maxDaysFeeWarning: any = false;
  takeFee: any = true;
  withoutFee = false;
  mkrFee: any = 0;
  daysExpire = 15;

  // FEEDBACK
  feedbackData: any = {};
  traidWindowData: any = {};
  isSentFeedBack: any = {};

  // VALUE
  calculator: any = {};
  calculator2: any = {};
  currencyValue: any = {};
  currencySymbol: any = {};
  currencyVal: any = {};
  currencyName: any = [];
  checkOptionSelect: boolean = false;
  focusCoinAmount: boolean = true;
  focusCurrencyAmount: boolean = true;
  focusValue: boolean;
  valueCoin: any = 0;
  isSelectedCoin: boolean = false;
  public imgUrl: any = environment.imgUrl;
  language: any;
  isOutSidePage: boolean = false;

  constructor(
    private walletService: WalletService,
    private userService: UserService,
    private otcService: OtcService,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private toast: ToastrService,
    private lang: LangService,
    private translate: TranslateService,
    private cookieService: CookieService,
    public sliceAmount: SliceAmount,
    private location: PlatformLocation
  ) {
    const token = this.userService.getToken();
    this.isActiveSroll = true;
    this.userData = this.userService.getLoggedData();
    if (!this.userData.preferredLanguage) {
      this.userData.preferredLanguage = 'en';
    }

    this.userService.changeData.pipe(takeUntil(this.unsubscribe$)).subscribe(isOpen => {
      this.userData = this.userService.getLoggedData();
      if (token.token === '' || token.token === undefined) {
        const Curriencies = this.cookieService.get('LocalCurrencies');
        if (Curriencies) {
          this.currencies = this.currencyVallues = Curriencies ? JSON.parse(Curriencies) : [];

        } else {
          this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
            if (m.status === 200) {
              this.currencies = m.data;
            }
          });
        }
        this.isOutSidePage = false;
      } else {
        if (!this.userData.preferredLanguage) {
          this.userData.preferredLanguage = 'en'
        }
        this.currencies = this.currencies.sort((a, b) => {
          if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]
            < b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
            return -1;
          }
          if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))] >
            b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
            return 1;
          }
          // names must be equal
          return 0;
        });
        this.isOutSidePage = true;
      }
    });
  }

  checkCalculatorFocus() {
    if (!GlobalConstants.calculatorFocus) {
      GlobalConstants.calculatorFocus = true;

      this.coinsList();
      this.getCurrentMoneyValue(this.currencies);
      setTimeout(() => {
        this.clearInput()
        if (document.getElementById('coinAmount') !== null)
          document.getElementById('coinAmount').focus();
      }, 300);
    }
  }

  ngOnInit() {
    const token = this.userService.getToken();
    this.activeRoute.queryParams.subscribe(params => {
      const token = params.token;
      this.tokenApp = Boolean(token);
    });
    this.language = (token.token === '' || token.token === undefined) ? (this.cookieService.get('OBSIDIAM-LOCALE') || 'en') : (this.userData.preferredLanguage || 'en');
    // console.log('this.language1', token, this.userData.preferredLanguage, this.cookieService.get('OBSIDIAM-LOCALE'))
    this.userService.changeLanguageEvent2.pipe(takeUntil(this.unsubscribe$)).subscribe((lang) => {
      this.language = lang || 'en';
      console.log('this.language2', this.language)
    });
    if (token.token === '' || token.token === undefined) {
      const Curriencies = this.cookieService.get('LocalCurrencies');
      if (Curriencies) {
        this.currencies = this.currencyVallues = Curriencies ? JSON.parse(Curriencies) : [];
      } else {
        this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
          if (m.status === 200) {
            this.currencies = m.data;
          }
        });
      }
      const cur = this.currencies.shortName;
      if (cur) {
        this.setCurrencyOrder(cur);
      }
      this.isOutSidePage = false;
    } else {
      const Curriencies = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
      if (Curriencies) {
        this.currencies = this.currencyVallues = Curriencies ? JSON.parse(Curriencies).sort((a, b) => {
          if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]
            < b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
            return -1;
          }
          if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))] >
            b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
            return 1;
          }
          // names must be equal
          return 0;
        }) : [];
      } else {
        this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
          if (m.status === 200) {
            this.currencies = m.data.sort((a, b) => {
              if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]
                < b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
                return -1;
              }
              if (a['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))] >
                b['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]) {
                return 1;
              }
              // names must be equal
              return 0;
            });
          }
        });
      }
      const cur = this.currencies.find((a) => {
        a.shortName === this.userData.preferredCurrency;
      });
      if (cur) {
        this.setCurrencyOrder(cur);
      }
      this.isOutSidePage = true;

    }

    this.dropDownsControl();
    this.javascriptControls();
    this.getMarketPrice();
    this.getCountries();
    this.coinsList();
    this.getCurrentMoneyValue(this.currencies);

  }

  javascriptControls() {
    $(document).on('click', (event) => {
      const $trigger = $('.drop_down').parent();
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        this.availablePaymentMethodsList = [];
        this.listTypes = [];
        this.currenciesList = [];
      }
    });
  }

  ngOnDestroy(): void {
    this.isActiveSroll = false;
    this.disConnectSockets();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  copyButton(inputElement1, inputElement2, inputElement3) {
    if (inputElement1.value !== '' && inputElement2.value !== '' && inputElement3.value !== '') {
      let value = document.createElement('input');
      inputElement1.select();
      document.execCommand('copy');
      inputElement1.setSelectionRange(0, 0);
      inputElement2.select();
      document.execCommand('copy');
      inputElement2.setSelectionRange(0, 0);
      inputElement3.select();
      document.execCommand('copy');
      inputElement3.setSelectionRange(0, 0);
      value.value = inputElement1.value + ' ' + this.selectedCoin.shortName + ' = ' + inputElement2.value + ' ' + this.selectedCoin2.shortName + ' = ' + inputElement3.value + ' ' + this.buySellCurrency;
      document.body.appendChild(value);
      value.select();
      document.execCommand('copy');
      document.body.removeChild(value);
      this.translate.get('success').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
        this.translate.get('buy_sell_detail.message_copy_calculator').pipe(takeUntil(this.unsubscribe$)).subscribe((msg: any) => {
          const messages = msg;
          const err = er;
          this.toast.success(messages, err, {
            timeOut: 15000
          });
        });
      });
    } else {
      this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
        this.translate.get('buy_sell_detail.message_error_calculator').pipe(takeUntil(this.unsubscribe$)).subscribe((msg: any) => {
          const messages = msg;
          const err = er;
          this.toast.error(messages, err, {
            timeOut: 15000
          });
        });
      });
    }


  }

  coinsList() {
    this.loading = true;
    const token = this.userService.getToken();
    this.walletService.getCoinList().pipe(takeUntil(this.unsubscribe$))
    .toPromise().then((m: any) => {
        this.loading = false;
        if (m.status === 200) {
          for (let i of m.data.filter((p) => p.active)) {
            if (i.shortName === this.selectedCoinShortName) {
              this.selectedCoin = i || {};
              this.coinName = this.selectedCoin.fullName;
              this.markerPrice = (Number(this.selectedCoin.priceUsd)).toFixed(2);

            }
          }
          this.coinList = m.data.filter((c) => c.active && c.cryptoType !== 'FIAT');
          this.selectedCoin = this.coinList;
          this.getNameOfCoin(this.selectedCoin);

        }
      });
  }

  dropDownsControl() {
    $(document).on('click', (e) => {
      if (e && e.target && e.target.id) {
        if (e.target && e.target.id !== 'orderTypeValue1' && e.target.id !== 'orderTypeImg1' &&
          e.target.id !== 'orderTypeValue2' && e.target.id !== 'orderTypeImg2' && this.listTypes && this.listTypes.length) {
          this.listTypes = [];
        }

        if (e.target && e.target.id !== 'paymentMethodValue' && e.target.id !== 'paymentMethodImg' && e.target.id !== 'paymentMethodP'
          && e.target.id !== 'paymentMethodIcon' && e.target.id !== 'paymentMethodDiv' && e.target.id !== 'paymentMethodValue2'
          && e.target.id !== 'paymentMethodImg2' && e.target.id !== 'paymentMethodP2' && e.target.id !== 'paymentMethodIcon2'
          && e.target.id !== 'paymentMethodDiv2' && this.availablePaymentMethodsList && this.availablePaymentMethodsList.length) {
          this.availablePaymentMethodsList = [];
        }

        if (e.target && e.target.id !== 'currencyValue' && e.target.id !== 'currencyImg' && e.target.id !== 'currencyOrderValue'
          && e.target.id !== 'currencyOrderImg' && e.target.id !== 'currencySpan' && e.target.id !== 'currencyDiv' && this.currenciesList && this.currenciesList.length) {
          this.currenciesList = [];
        }

        if (e.target && e.target.id !== 'countryPM' && e.target.id !== 'countryPMImg' && this.countryListPM && this.countryListPM.length) {
          this.currenciesList = [];
          $('#countryPMDrop').hide();
        } else {
          $('#countryPMDrop').show();
        }

        if (e.target && e.target.id !== 'bankPM' && e.target.id !== 'bankPMImg' && this.bankListPM && this.bankListPM.length) {
          this.bankListPM = [];
          $('#bankPMDrop').hide();
        } else {
          $('#bankPMDrop').show();
        }

        if (e.target && e.target.id !== 'giftCardPM' && e.target.id !== 'giftCardPMImg' && this.giftCardsList && this.giftCardsList.length) {
          this.giftCardsList = [];
          $('#giftCardPMDrop').hide();
        } else {
          $('#giftCardPMDrop').show();
        }

        if (e.target && e.target.id !== 'coinsValue' && e.target.id !== 'coinsSpan' && e.target.id !== 'coinsImg'
          && e.target.id !== 'coinsDiv' && e.target.id !== 'coinsValue2' && e.target.id !== 'coinsSpan2'
          && e.target.id !== 'coinsImg2' && e.target.id !== 'coinsDiv2' && this.coinsListFilter && this.coinsListFilter.length) {
          this.coinsListFilter = [];
        }

        if (e.target && e.target.id !== 'coinsValue3' && e.target.id !== 'coinsSpan3' && e.target.id !== 'coinsImg3'
          && e.target.id !== 'coinsDiv3' && this.coinsListFilter2 && this.coinsListFilter2.length) {
          this.coinsListFilter2 = [];
        }
      }
    });
  }

  getCoins() {
    if (!this.coinsListFilter.length) {
      this.coinsListFilter = this.coinList.filter(c => c.active);
      // console.log(this.coinsListFilter);
    } else {
      this.coinsListFilter = [];
    }
  }

  getCoins2() {
    if (!this.coinsListFilter2.length) {
      this.coinsListFilter2 = this.coinList.filter(c => c.active);
    } else {
      this.coinsListFilter2 = [];
    }
  }

  disConnectSockets() {
    if (this.priceStompClient && this.priceStompClient.connected) {
      this.priceStompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect price socket');
        }
      });
    }
  }


  getMarketPrice() {
    const url = environment.apiUrl + environment.socketUrl;
    const socket = new SockJS(url);
    if (socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    this.priceStompClient = Stomp.over(socket);
    this.priceStompClient.reconnect_delay = 5000;
    this.priceStompClient.heartbeatIncoming = 4000;
    this.priceStompClient.heartbeatOutgoing = 4000;
    this.priceStompClient.heartbeat.outgoing = 4000;
    this.priceStompClient.heartbeat.incoming = 4000;
    if (this.priceStompClient.connected) {
      this.priceStompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect price socket');
        }
      });
    }
    if (environment.production) {
      this.priceStompClient.debug = () => {
      };
    }
    const token = this.userService.getToken();
    if (token.token === '' || token.token === undefined) {
      if (!environment.production) {
        console.log('Entro al else de marketPrices');
      }
    } else {
      // this.priceStompClient.heartbeat.outgoing = 0;
      // this.priceStompClient.heartbeat.incoming = 20000;
      this.priceStompClient.connect({
        Authorization: 'Bearer ' + token.token,
        From: 'price'
      }, (frame) => {
        this.socketConnected = true;

        if (!environment.production) {
          console.log('socket price connected:', true);
          console.log('Connected: ' + frame);
        }
        this.priceStompClient.subscribe('/topic/otc/price/' + this.selectedCoinShortName, (greeting) => {
          // if (!environment.production) {
          //   console.log('after subscribe:', JSON.parse(greeting.body), greeting);
          // }
          this.fecthMarketPrice = new Date();
          this.markerPrice = JSON.parse(greeting.body).price;

        });

        this.priceStompClient.subscribe('/topic/otc/price/' + this.selectedCoinShortName2, (greeting) => {
          // if (!environment.production) {
          //   console.log('after subscribe:', JSON.parse(greeting.body), greeting);
          // }
          this.fecthMarketPrice = new Date();
          this.markerPrice2 = JSON.parse(greeting.body).price;

        });
      }, (err) => {
        if (!environment.production) {
          console.log('Socket disconnect automatically', err);
        }
        /*setTimeout(() => {
          this.getMarketPrice();
        }, 2000);*/
      });
    }
  }

  getCurrencyList() {
    if (!this.currenciesList.length) {
      this.currenciesList = this.currencies;
    } else {
      this.currenciesList = [];
    }
  }

  getCurrency(cur) {
    if (cur) {
      const curency = this.currencies.filter((m) => m.shortName === cur);
      return curency[0];
    } else {
      return {
        shortName: this.userData.preferredCurrency ? this.userData.preferredCurrency.shortName : 'USD',
        symbol: this.userData && this.userData.preferredCurrency ? this.userData.preferredCurrency.symbol : '$',
        value: 1
      };
    }
  }

  setCoinFilter(c: any) {
    if (this.priceStompClient && this.priceStompClient.connected) {
      $('#coinsValue, #coinsValue2').val(c.shortName);
      this.coinName = c.fullName;
      this.coinsListFilter = [];
      this.selectedCoinShortName = c.shortName;
      if (this.focusCoinAmount === false && this.focusValue === false) {
        this.focusCurrencyAmount = true;
        this.focusCoinAmount = false;
      }
      if (this.focusCurrencyAmount === true && this.focusValue === true) {
        this.focusCurrencyAmount = false;
        this.focusCoinAmount = true;
        this.valueCoin = Number($('#coinAmount').val());
      }
      this.priceStompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect price socket');
        }
      });
      for (let i of this.coinList.filter((p) => p.active)) {
        if (i.shortName === this.selectedCoinShortName) {
          this.selectedCoin = i || {};
          this.markerPrice = this.selectedCoin.priceUsd;
        }
      }
      this.getMarketPrice();
    } else {
      if (!environment.production) {
        console.log('WEBSOCKET PRICE DISCONNECTED');
      }
      this.isSelectedCoin = true;
      this.selectedCoinShortName = c.shortName;
      this.coinsListFilter = [];
      for (let i of this.coinList.filter((p) => p.active)) {
        if (i.shortName === this.selectedCoinShortName) {
          this.selectedCoin = i || {};
          this.markerPrice = this.selectedCoin.priceUsd;
        }
      }
    }
  }

  getCurrencyValue() {

    return Number($('#currencyAmount').val());
  }

  getCoinValue() {
    const part = /^(\d|)?(\d|,)*\.?\d*$/;
    let val = part.exec($('#coinAmount').val());
    if (!val) {
      $('#coinAmount').val(this.calculator.amount);
    } else {
      return Number($('#coinAmount').val());
    }
  }

  setCoinFilter2(c: any) {
    if (this.priceStompClient && this.priceStompClient.connected) {
      $('#coinsValue3, #coinsValue3').val(c.shortName);
      this.coinName2 = c.fullName;
      this.coinsListFilter2 = [];
      this.selectedCoinShortName2 = c.shortName;
      this.priceStompClient.disconnect(() => {
        if (!environment.production) {
          console.log('disconnect price socket');
        }
      });
      this.walletService.getCoinPrice(this.selectedCoinShortName2).pipe(takeUntil(this.unsubscribe$))
      .toPromise().then((m: any) => {
          if (m.status === 200) {
            this.selectedCoin2 = m.data || {};
            this.markerPrice2 = this.selectedCoin2.price;
          }
        });
      this.getMarketPrice();
    } else {
      if (!environment.production) {
        console.log('WEBSOCKET PRICE DISCONNECTED');
      }
    }
  }

  setCurrencyOrder(currency: any) {
    const token = this.userService.getToken();
    if (token.token === '' || token.token === undefined) {
      $('#currencyOrderValue').val(currency ? currency['fullName' + (this.language == 'en' ? '' : (this.language.toUpperCase()))] : '');
      this.buySellCurrencyName = currency ? currency['fullName' + (this.language == 'en' ? '' : (this.language.toUpperCase()))] : '';
      this.buySellCurrency = currency.shortName;
      this.currenciesList = [];
      this.currencyValue = currency.value;
      this.currencySymbol = this.currencyName ? this.currencyName.symbol : '$';
    } else {
      $('#currencyOrderValue').val(currency['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))]);
      this.buySellCurrencyName = currency['fullName' + (this.userData.preferredLanguage == 'en' ? '' : (this.userData.preferredLanguage.toUpperCase()))];
      this.buySellCurrency = currency.shortName;
      this.currenciesList = [];
      this.currencyValue = currency.value;
      this.currencySymbol = this.userData && this.userData.preferredCurrency ? this.userData.preferredCurrency.symbol : '$';

    }
  }

  setCurrencyListFilter(currency: any) {

    if (currency !== 'ALL') {
      $('#currencyValue').val(currency ? currency['fullName' + (this.userData.preferredLanguage == 'en' ? '' :
        (this.userData.preferredLanguage.toUpperCase()))] : '');
      this.filter.preferredCurrency = currency.shortName;
    } else {
      this.translate.get('buy_sell_detail.all').pipe(takeUntil(this.unsubscribe$)).subscribe((all: any) => {
        $('#currencyValue').val(all);
      });
      this.filter.preferredCurrency = 'ALL';
    }
    this.currenciesList = [];
  }

  setCountryFilter(country: any, all: boolean) {
    if (!all) {
      this.filter.country.push(country.item_text);
    } else {
      for (const countryL of this.countries) {
        this.filter.country.push(countryL.name);
      }
    }
  }

  setPaymentMethodsListFilter(py: any, resize: boolean = false) {
    if (py.name === 'National Bank Transfer' || py.name === 'International Bank Transfer') {
      $('#currencyOrderValue').val('');
      this.currenciesList = [];
    }

    if (!resize) {
      this.filter.paymentMethod = py === 'ALL' ? 'ALL' : py.name;
      this.filter.paymentMethodImage = py === '' ? '' : py.imageUrl;
      this.availablePaymentMethodsList = [];
    }

    this.translate.get('buy_sell_detail.orderTypes').pipe(takeUntil(this.unsubscribe$)).subscribe((types: any) => {
      setTimeout(() => {
        $('#orderTypeValue1').val(types.length ? (this.type.toLowerCase() === 'buy' ? types[0] : types[1]) : '');
        $('#orderTypeValue2').val(types.length ? (this.type.toLowerCase() === 'buy' ? types[0] : types[1]) : '');
        this.filter.preferredCurrency = 'ALL';
        if (!this.selectedItems.length) {
          this.selectedItems = this.dropdownList;
          this.setCountryFilter('', true);
          this.filter.country.push('');
        }
        this.translate.get('buy_sell_detail.all').pipe(takeUntil(this.unsubscribe$)).subscribe((all: any) => {
          $('#currencyValue').val(all);
        });
      }, 50);
    });
  }


  getPaymentMethodsList(event) {
    if (!this.availablePaymentMethodsList.length && this.checkOptionSelect === false) {
      this.availablePaymentMethodsList = this.availablePaymentMethods;
    } else {
      this.availablePaymentMethodsList = [];
    }
  }

  getAvailablePaymentMethods() {
    this.loading = true;
    this.otcService.getAvailablePaymeentMethods(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
      this.loading = false;
      if (m.status === 200) {
        // if (!environment.production) {
        //   console.log('AVAILABLE METHODS', m.data);
        // }
        let methods: any = [], other: any;
        for (let i = 0; i < m.data.length; i++) {
          if (m.data[i].name == 'Other') {
            other = m.data[i];
          } else {
            methods.push(m.data[i]);
          }
        }
        methods.push(other);
        this.availablePaymentMethods = methods.map((a) => {
          a.payload = a.payload ? JSON.parse(a.payload) : {};
          a.active = false;
          a.paymentMethodCountries = a.paymentMethodCountries || [];
          return a;
        });


      } else {
        this.toast.clear();
        this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
          const msg = m.message;
          const err = er;
          this.toast.error(msg, err, {
            timeOut: 15000
          });
        });
      }
    });
  }


  getAvailableBanks() {
    this.loading = true;
    this.otcService.getAvailableBanks(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
      this.loading = false;
      if (m.status === 200) {
        this.availableBanks = m.data;
      } else {
        this.toast.clear();
        this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
          const msg = m.message;
          const err = er;
          this.toast.error(msg, err, {
            timeOut: 15000
          });
        });
      }
    });
  }

  getCountries() {
    this.loading = true;
    this.otcService.getCountries(this.userData.token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
      this.loading = false;
      if (m.status === 200) {
        this.countries = m.data;

        this.dropdownList = [];
        for (let countryIndex = 0; countryIndex < this.countries.length; countryIndex++) {
          this.dropdownList.push({ item_id: countryIndex + 1, item_text: this.countries[countryIndex].name });
        }

        this.selectedItems = [];

        this.translate.get('buy_sell_detail.select_all').pipe(takeUntil(this.unsubscribe$)).subscribe((selectText: any) => {
          this.translate.get('buy_sell_detail.unselect_all').pipe(takeUntil(this.unsubscribe$)).subscribe((unselectText: any) => {
            this.dropdownSettings = {
              singleSelection: false,
              idField: 'item_id',
              textField: 'item_text',
              selectAllText: selectText,
              unSelectAllText: unselectText,
              itemsShowLimit: 1,
              allowSearchFilter: true
            };
          });
        });
      } else {
        this.toast.clear();
        this.translate.get('error').pipe(takeUntil(this.unsubscribe$)).subscribe((er: any) => {
          const msg = m.message;
          const err = er;
          this.toast.error(msg, err, {
            timeOut: 15000
          });
        });
      }
    });
  }

  getNameOfCoin(value: any) {
    for (const ix of value) {
      if (ix.shortName === 'BTC') {
        this.selectedCoinShortName = ix.shortName;
        for (const i of this.coinList.filter((p) => p.active)) {
          if (i.shortName === this.selectedCoinShortName) {
            this.selectedCoin = i || {};
            this.coinName = this.selectedCoin.fullName;
            this.markerPrice = this.selectedCoin.priceUsd;
          }
        }
      } else if (ix.shortName === 'ETH') {
        this.selectedCoinShortName2 = ix.shortName;
        for (const i of this.coinList.filter((p) => p.active)) {
          if (i.shortName === this.selectedCoinShortName) {
            this.selectedCoin2 = i || {};
            this.coinName = this.selectedCoin2.fullName;
            this.markerPrice2 = this.selectedCoin2.priceUsd;
          }
        }
      }
    }
  }

  getCurrentMoneyValue(coin: any) {
    const token = this.userService.getToken();
    if (token.token === '' || token.token === undefined) {
      this.walletService.getCurrencies().pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
        if (m.status === 200) {
          this.currencies = m.data;
          for (let i of this.currencies) {
            if (i.shortName === 'USD') {
              this.setCurrencyOrder(i);
            }
          }
        }
      });
    } else {
      for (let i of coin) {
        if (this.getCurrency(this.userData.preferredCurrency.shortName).shortName === i.shortName) {
          this.setCurrencyOrder(i);
        }
      }
    }

  }

  updateAmount() {
    const part = /^(\d|)?(\d|)*\.?\d*$/;
    let val = part.exec($('#coinAmount').val());
    if (!val) {
      $('#coinAmount').val(this.calculator.amount);
    } else {
      this.focusCurrencyAmount = false;
      this.focusCoinAmount = true;
      this.calculator.amount = $('#coinAmount').val();
    }
  }


  updateAmountCurrency() {
    const part = /^(\d|)?(\d|,)*\.?\d*$/;
    let val = part.exec($('#currencyAmount').val());
    if (!val) {
      $('#currencyAmount').val(this.currencyVal.amountCurrency);
    } else {
      const parts2 = $('#currencyAmount').val().toString().split('.');
      parts2[0] = parts2[0].split(',').join('');
      parts2[0] = parts2[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // console.log(parts2[0])
      $('#currencyAmount').val(parts2.join('.'));
      this.focusCoinAmount = false;
      this.focusCurrencyAmount = true;
      this.currencyVal.amountCurrency = $('#currencyAmount').val().split(',').join('');
      // console.log(this.focusCurrencyAmount,this.currencyVal.amountCurrency,this.currencyValue,this.markerPrice,((this.currencyVal.amountCurrency / (this.currencyValue * this.markerPrice))))
    }
  }

  updateAmount2() {
    const part = /^(\d|)?(\d|,)*\.?\d*$/;
    let val = part.exec($('#coinAmount2').val());
    if (!val) {
      $('#coinAmount2').val('');
    } else {
      this.calculator2.amount2 = $('#coinAmount2').val();
    }
  }

  showAdvance() {
    this.filter.advance = !this.filter.advance;
    $('.openOption').slideToggle({
      start() {
        $(this).css('display', 'block');
        $(this).css('margin', '5px');
      }
    });
  }

  focusInput(val: string) {
    const value = '#' + val;
    if ($(`${value}`).is(':focus')) {
      if (`${value}` === '#coinAmount') {
        this.focusValue = true;
        return this.focusValue;
      }
      if (`${value}` === '#currencyAmount') {
        this.focusValue = false;
        return this.focusValue;
      }

    }
  }

  disableDropDown() {
    if ($('#inlineCheckbox1').is(':checked')) {
      this.checkOptionSelect = true;
      $('#paymentMethodValue').removeClass('cursorPointer');
      $('#paymentMethodP').removeClass('cursorPointer');
      $('#paymentMethodDiv').removeClass('cursorPointer');
      $('#disableElement').css({ 'background-color': '#F1F1F1' });
      $('#paymentMethodImg').css({ 'background-color': '#F1F1F1' });
      $('#paymentMethodImg').removeClass('cursorPointer');
    } else {
      this.checkOptionSelect = false;
      $('#paymentMethodValue').addClass('cursorPointer');
      $('#paymentMethodP').addClass('cursorPointer');
      $('#disableElement').css('background-color', '#FFFFFF');
      $('#paymentMethodImg').css({ 'background-color': '#FFFFFF' });
      $('#paymentMethodImg').addClass('cursorPointer');
    }

  }

  clearInput() {
    $('#coinAmount').val(0);
    $('#currencyAmount').val(0);
    this.calculator.amount = '';
    this.currencyVal.amountCurrency = '';

  }
}
